<template>
  <el-select
    style="width: 100%"
    size="small"
    placeholder="Выберите сервер"
    filtertable
    v-on="$listeners"
    :value="idReserveDvrServer == currentIdServer ? null : idReserveDvrServer"
    :disabled="!currentMassClusterAlias"
    @change="change"
  >
    <el-option v-for="server in reserveDvrServers" :key="server.id" :label="server.name" :value="server.id">
      <span class="left_info">{{ server.name }}</span>
      <span class="right_info">
        <span :class="server.classStreams">
          <fa :icon="['fas', 'exchange-alt']" />
          {{ server.freely_streams }}
        </span>
        <span :class="server.classArchive">
          <fa :icon="['fas', 'database']" />
          {{ server.freely_archive }}
        </span>
      </span>
    </el-option>
  </el-select>
</template>

<script>
import { FontAwesomeIcon as fa } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExchangeAlt, faDatabase } from "@fortawesome/free-solid-svg-icons";
import { mapActions, mapState } from "vuex";
library.add(faExchangeAlt, faDatabase);

export default {
  name: "ReserveServerSelect",
  components: {
    fa,
  },
  model: {
    prop: "idReserveDvrServer",
    event: "change",
  },
  props: {
    idReserveDvrServer: {
      type: Number,
      default: null,
    },
    currentIdServer: {
      type: Number,
      default: null,
    },
    currentMassClusterAlias: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState("server", {
      reserveDvrServers: (state) =>
        state.reserveDvrServers.map((server) => {
          const customServer = Object.assign({}, server);
          customServer.classStreams = server.freely_streams <= 0 ? "color_alert" : "color_recommend";
          customServer.classArchive = server.freely_archive <= 0 ? "color_alert" : "color_recommend";

          return customServer;
        }),
    }),
  },
  watch: {
    currentMassClusterAlias() {
      this.update();
    },
  },
  methods: {
    change(id) {
      this.idReserveDvrServer = id;
    },
    update() {
      this.updateReserve({ id: this.currentIdServer, clusterAlias: this.currentMassClusterAlias });
    },
    ...mapActions("server", {
      updateReserve: "GET_RECOMMENDED_RESERVE_SERVERS",
    })
  },
  created() {
    if (this.currentMassClusterAlias) this.update();
  },
}
</script>

<style>
.left_info {
  float: left;
  padding-right: 5px;
}
.right_info {
  float: right;
  text-align: left;
  min-width: 130px;
}
.color_recommend {
  color: #8bc34a;
}
.color_alert {
  color: #f44336;
}
</style>
